import React from "react";
import { Modal } from "react-bootstrap";
import { HiOutlineShieldExclamation } from "react-icons/hi";
import { IoKeyOutline } from "react-icons/io5";
import useTranslator from "../../hooks/useTranslator";
import { formatPropertyAddress } from "../../helper/common";
import "./VacatePropertyModal.css";

const VacatePropertyModal = ({
  show,
  onHide,
  onConfirm,
  isLoading,
  property,
  currentLang,
  hasActiveInsurance,
}) => {
  const { _t } = useTranslator();
  const propertyName =
    formatPropertyAddress(property, currentLang) ||
    property?.address ||
    _t("thisProperty");

  return (
    <Modal
      show={show}
      onHide={onHide}
      centered
      backdrop="static"
      className="vacate-property-modal"
    >
      <Modal.Body>
        <div className="vacate-property-icon">
          <IoKeyOutline />
        </div>
        <h2>{_t("vacateThisProperty")}</h2>
        <p className="vacate-property-description">
          {_t("vacating")} <strong>{propertyName}</strong>{" "}
          {_t("willRemoveAllTenantsAndLeavePropertyVacant")}
        </p>
        {hasActiveInsurance && (
          <div className="vacate-property-insurance-warning">
            <HiOutlineShieldExclamation />
            <div>
              <strong>{_t("propertyHasActiveNonPaymentInsurance")}</strong>
              <p>{_t("vacatingStartsInsuranceReview")}</p>
            </div>
          </div>
        )}
        <div className="vacate-property-actions">
          <button
            type="button"
            className="vacate-property-cancel"
            onClick={onHide}
            disabled={isLoading}
          >
            {_t("cancel")}
          </button>
          <button
            type="button"
            className="vacate-property-confirm"
            onClick={onConfirm}
            disabled={isLoading}
          >
            {_t("vacateProperty")}
          </button>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default VacatePropertyModal;
